import { addHook, useFeatureFlags } from '@viveaesthetics/elemy-shared-core'
import {
  useCustomerIOAnalytics,
  useSegmentAnalytics
} from '@viveaesthetics/shared-domain'

import {
  AnalyticsEvents,
  NewTherapistAnalyticsEvents,
  ReferralNewTherapistBookingFormFieldChanged
} from '@/types/analyticsEvents'

import { useParams } from '../useParams'

export const useTimeSlotAnalytics = addHook({
  useTimeSlotAnalytics: () => {
    const { selectProvider, useCase } = useParams<{
      selectProvider?: string
      useCase?: string
    }>()
    const segmentAnalytics = useSegmentAnalytics<
      | AnalyticsEvents
      | NewTherapistAnalyticsEvents
      | ReferralNewTherapistBookingFormFieldChanged
    >()
    const customerIOAnalytics = useCustomerIOAnalytics<
      | AnalyticsEvents
      | NewTherapistAnalyticsEvents
      | ReferralNewTherapistBookingFormFieldChanged
    >()

    const flags = useFeatureFlags()

    const isSegmentClientDataEnabled = flags['pfp-3891-segment-client-data']

    const getEventNames = () => {
      if (useCase === 'referral') {
        return {
          formFieldChangedEvent:
            ReferralNewTherapistBookingFormFieldChanged.REFERRAL_NEW_THERAPIST_BOOKING_FORM_FIELD_CHANGED,
          timeSlotSelectedEvent:
            ReferralNewTherapistBookingFormFieldChanged.REFERRAL_NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED
        }
      }
      if (selectProvider) {
        return {
          formFieldChangedEvent:
            NewTherapistAnalyticsEvents.NEW_THERAPIST_BOOKING_FORM_FIELD_CHANGED,
          timeSlotSelectedEvent:
            NewTherapistAnalyticsEvents.NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED
        }
      }
      return {
        formFieldChangedEvent: AnalyticsEvents.BOOKING_FORM_FIELD_CHANGED,
        timeSlotSelectedEvent: AnalyticsEvents.BOOKING_TIME_SLOT_SELECTED
      }
    }

    const { formFieldChangedEvent, timeSlotSelectedEvent } = getEventNames()
    const setTimeSlotAnalytics = ({
      providerId,
      timeSlot
    }: {
      providerId: string
      timeSlot: Date
    }) => {
      customerIOAnalytics.trackEvent(formFieldChangedEvent, {
        fieldName: 'timeSlot',
        fieldValue: timeSlot
      })

      segmentAnalytics.trackEvent(formFieldChangedEvent, {
        fieldName: 'timeSlot',
        fieldValue: isSegmentClientDataEnabled ? timeSlot : ''
      })

      customerIOAnalytics.trackEvent(
        selectProvider
          ? NewTherapistAnalyticsEvents.NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED
          : AnalyticsEvents.BOOKING_TIME_SLOT_SELECTED,
        {
          therapist_id: providerId,
          time_slot: timeSlot
        }
      )

      segmentAnalytics.trackEvent(
        timeSlotSelectedEvent,
        isSegmentClientDataEnabled
          ? {
              therapist_id: providerId,
              time_slot: timeSlot
            }
          : undefined
      )
    }

    return { setTimeSlotAnalytics }
  }
})
